import { render, staticRenderFns } from "./SpotlightBar.vue?vue&type=template&id=1d9573ee&scoped=true&"
import script from "./SpotlightBar.vue?vue&type=script&lang=ts&"
export * from "./SpotlightBar.vue?vue&type=script&lang=ts&"
import style0 from "./SpotlightBar.vue?vue&type=style&index=0&id=1d9573ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9573ee",
  null
  
)

export default component.exports